import React from 'react';
import './AboutSection.css';
import img1 from '../assets/2.png';
import img2 from '../assets/3.png';

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-left">
        <h2>About Gowri Prasanna Convention Hall (GMB Complex)</h2>
        <p>
          Since 2010, Gowri Prasanna Convention Hall (GMB Complex) has been the premier destination for
          memorable events in the heart of Tumakuru. Our convention hall combines
          timeless elegance with modern amenities to create the perfect setting
          for your special occasions.
        </p>
        <div className="about-stats">
          <div className="about-stat">
            <div className="stat-bar" />
            <div>
              <div className="stat-number">1000+</div>
              <div className="stat-label">Events Hosted</div>
            </div>
          </div>
          <div className="about-stat">
            <div className="stat-bar" />
            <div>
              <div className="stat-number">450</div>
              <div className="stat-label">Seating Capacity</div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-right">
        <img src={img1} alt="Convention hall decorated for event" />
        <img src={img2} alt="Convention hall stage setup" />
      </div>
    </section>
  );
};

export default AboutSection;
